import { ReleaseUiState } from '@/store/modules/releaseUi/types'

export const state: ReleaseUiState = {
  interacted: false,
  releaseUpgradeConfirmationDialogVisible: false,
  releasesLoaded: false,
}
